// @ts-check
// ====== F2: Data layer commenti clienti ======

const commentiApi = {
  /**
   * Lista commenti per un cliente, dal più recente.
   * @param {string} clienteId
   */
  async list(clienteId) {
    // @ts-ignore — sb globale
    const { data, error } = await sb
      .from('commenti_clienti')
      .select('id, user_id, user_name, testo, created_at, updated_at')
      .eq('cliente_id', clienteId)
      .order('created_at', { ascending: false })
      .limit(200);
    if (error) throw error;
    return data || [];
  },

  /**
   * @param {string} clienteId
   * @param {string} testo
   */
  async add(clienteId, testo) {
    const t = (testo || '').trim();
    if (!t) throw new Error('Il commento è vuoto');
    if (t.length > 5000) throw new Error('Massimo 5000 caratteri');
    // @ts-ignore
    const { data: auth } = await sb.auth.getUser();
    const uid = auth?.user?.id;
    if (!uid) throw new Error('Utente non autenticato');
    // @ts-ignore — getCurrentUser globale
    const me = typeof getCurrentUser === 'function' ? getCurrentUser() : null;
    // @ts-ignore
    const { data, error } = await sb
      .from('commenti_clienti')
      .insert({
        cliente_id: clienteId,
        user_id: uid,
        user_name: me?.name || (me?.email || '').split('@')[0] || 'Utente',
        testo: t
      })
      .select('*')
      .single();
    if (error) throw error;
    return data;
  },

  /**
   * @param {string} id
   * @param {string} testo
   */
  async update(id, testo) {
    const t = (testo || '').trim();
    if (!t) throw new Error('Il commento è vuoto');
    // @ts-ignore
    const { data, error } = await sb
      .from('commenti_clienti')
      .update({ testo: t })
      .eq('id', id)
      .select('*')
      .single();
    if (error) throw error;
    return data;
  },

  /** @param {string} id */
  async remove(id) {
    // @ts-ignore
    const { error } = await sb.from('commenti_clienti').delete().eq('id', id);
    if (error) throw error;
  }
};

// @ts-ignore — global
globalThis.commentiApi = commentiApi;
export {};
